import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    orgName: "",
  },
  reducers: {
    setToken(state, action) {
      state.isAuthenticated = true;
      state.orgName = action.payload;
    },
    clearAll(state) {
      state.isAuthenticated = false;
    },
  },
});

export const { setToken, clearAll } = authSlice.actions;

export default authSlice.reducer;
